import { DefaultApi } from "../../../api";
import { urls } from "../../../urls";
import { getCatchError } from '../../../getCatchError'

const setPostCreateFs = (params, setFs) => {
    return async (dispatch, getState) => {
        try {
            setFs(false)
            const newParams = {
                quantity: params.fsCount,
                uuid: params.game.uuid,
                id: params.id
            }

            await DefaultApi({
                params: newParams,
                method: 'post',
                url: urls.POST_CREATE_FS
            });
            alert(`${params.fsCount} FS успешно выданы. Игра: ${params.game.name}`)
        } catch (error) {
            //todo доделать catch
            setFs(false);
            getCatchError(error)
        }
    }
}

export {
    setPostCreateFs as SetPostCreateFs
}